import { mapState } from 'vuex'

const mixin = {
  computed: {
    ...mapState(['showTransliteratedField']),
    showTransliteration() {
      return this.showTransliteratedField
    }
  },
  mounted() {
    if (this.showTransliteration) {
      const parentFirstname = global.$('#firstname-transliteration')
      const parentLastname = global.$('#lastname-transliteration')
      const transliterateFirstname = parentFirstname.children()[0]
      const firstname = parentFirstname.children()[1]
      const transliterateLastname = parentLastname.children()[0]
      const lastname = parentLastname.children()[1]
      if (window.innerWidth < 800) {
        parentFirstname.append(transliterateFirstname, transliterateLastname)
        parentLastname.append(firstname, lastname)
      }
    }
  }
}

export default mixin
